import { useMemo } from "react";
import { AuthenticationProviderInterface } from "context/Auth/Context";
import { AdInterface } from "types/ad";

type UseAdServiceResult = {
    hasService: boolean;
    serviceId: string;
};

export const useAdService = (
    account: AuthenticationProviderInterface["account"],
    data: AdInterface | undefined,
): UseAdServiceResult =>
    useMemo(() => {
        if (!data) return { hasService: false, serviceId: "" };

        const services = account?.resources?.provider?.[0]?.provider_services ?? [];
        const match = services.find((service) => {
            if (service.category !== data.category) return false;
            if (!data.subcategory) return true;
            return service.subcategory === data.subcategory;
        });

        return {
            hasService: Boolean(match),
            serviceId: match?.id ?? "",
        };
    }, [account, data]);
